<div class="p-[1.875rem] relative">
    <button type="button" mat-dialog-close>
        <mat-icon
            svgIcon="close"
            class="absolute top-6 right-6 text-[#817F7F] hover:text-[#646363] !w-[17px]"></mat-icon>
    </button>

    <div class="w-full" [class.show-form-error]="isShowFormError">
        <h1 class="text-black font-semibold text-center text-2xl">{{ 'feedback.title' | translate }}</h1>

        <div class="mt-10 md:w-[39.375rem] md:px-[1.875rem]">
            <p class="text-[#5F5B5B] font-medium text-lg text-center">{{ 'feedback.description' | translate }}</p>

            <div class="mt-7 md:flex grid grid-cols-5 gap-4 md:gap-0 items-center justify-evenly md:space-x-3">
                @for (item of feedbackRatings; track item) {
                    <button
                        type="button"
                        class="rating-button"
                        [ngClass]="{
                            active: selectedRating === item.value,
                            error: isShowFormError && !selectedRating,
                        }"
                        (click)="selectedRating = item.value">
                        {{ item.title }}
                    </button>
                }
            </div>

            <div *ngIf="!selectedRating && isShowFormError" class="validation-error-message mt-2">
                {{ 'error.pleaseSelectARating' | translate }}
            </div>

            <div class="w-full justify-between flex items-center font-medium text-lg mt-5">
                <div class="text-[#E73A3A] text-center">{{ 'feedback.veryDissatisfied' | translate }}</div>
                <div class="">
                    <div class="h-[2px] w-0 md:w-[13.125rem] bg-[#C5C5C5] relative">
                        <mat-icon
                            svgIcon="dropdown-expand"
                            class="text-[#C5C5C5] absolute -right-[5px] top-[50%] translate-y-[-50%] rotate-90 !w-4"></mat-icon>
                    </div>
                </div>
                <div class="text-[#1A8B57] text-center">{{ 'feedback.verySatisfied' | translate }}</div>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="mt-12">
                    <div class="field-holder">
                        <textarea
                            class="w-full border-[1px] h-[9.375rem] border-[#CBCBCB] resize-none rounded-[6px] p-3 font-normal form-control"
                            formControlName="message"
                            [placeholder]="'feedback.textAreaPlaceholder' | translate"></textarea>
                    </div>
                </div>

                <div class="notice-section">
                    <div class="max-width-container">
                        <div class="p-[0.625rem] bg-[#FFDFDF] border-[#FF9696] border-[1px] rounded-lg w-fit mx-auto">
                            <div class="flex gap-[0.625rem] items-center">
                                <mat-icon svgIcon="alert" class="!min-w-5 text-[#E73A3A]"></mat-icon>
                                <div class="font-lato font-normal text-[#5F5B5B] text-base leading-5">
                                    {{ 'askAnExpert.ensureQueryIsFullyAddressedBeforeRate' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="submit" class="mt-7 !px-5 !py-3 btn-primary w-full md:!w-auto m-auto">
                    {{ 'button.submitFeedback' | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
